import { blockedOptionMessage } from "@utils/Index";
import { perfisVisitante } from "@utils/auth/perfis";

export const getUserFieldProperties = (field, perfilSelecionado, unitLoading = false) => {
    // Normaliza o perfil (trim + uppercase) para evitar divergências
    const perfil = (perfilSelecionado || "").trim().toUpperCase();

    const labels = {
        nome: "Nome do Usuário",
        email: "E-mail do Usuário",
        nomeUnidadeGerencia: "Unidade",
        solicitacao: "Nº da Solicitação"
    };

    const perfilSelecionadoValido = perfil.length > 0;

    const isVisitante = perfisVisitante.includes(perfil);

    // Bloqueia tudo até escolher um perfil
    if (!perfilSelecionadoValido) {
        return {
            isDisabled: true,
            placeholder: blockedOptionMessage,
        };
    }

    // Nome & Email sempre liberados após seleção de perfil
    if (field === "nome" || field === "email") {
        return {
            isDisabled: false,
            placeholder: `Preencher com o ${labels[field]?.toLowerCase() || field.toLowerCase()}`,
        };
    }

    // Solicitação e UnidadeGerencia: somente para VISITANTE
    if (field === "solicitacao" || field === "unidadeGerencia") {
        return {
            isDisabled: !isVisitante,
            placeholder: isVisitante
                ? "Preencher com o número da solicitação"
                : "Selecione o perfil Visistante para liberar",
        };
    }

    // Default
    return {
        isDisabled: true,
        placeholder: blockedOptionMessage,
    };
};
